"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effects_1 = require("redux-saga/effects");
var axios_1 = __importDefault(require("axios"));
var authSelectors_1 = require("../selectors/authSelectors");
var settingsSelectors_1 = require("../selectors/settingsSelectors");
var i18n_1 = __importDefault(require("../i18n"));
var reportErrorsToInstrumentation_1 = __importStar(require("../helper/reportErrorsToInstrumentation"));
var ClientAccountsState_1 = require("../states/ClientAccountsState");
var clientAccountsService_1 = require("../services/clientAccountsService");
var ClientAccount_1 = __importDefault(require("../models/ClientAccount"));
var ClientFamily_1 = __importDefault(require("../models/ClientFamily"));
var utils_1 = require("../helper/utils");
var authState_1 = require("../states/authState");
var effectsHelper_1 = require("./effectsHelper");
function getClientAccountsEffect(action) {
    var token, _a, clientId, customerAccountId, sectionSubscriptionId, version, familyId, data, clientAccounts, clientFamilies, e_1, language, errorMsg;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 14]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error('Missing Access Token');
                _a = action.payload, clientId = _a.clientId, customerAccountId = _a.customerAccountId, sectionSubscriptionId = _a.sectionSubscriptionId, version = _a.version, familyId = _a.familyId;
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.fetchClientsAccountsService, token, clientId, version)];
            case 2:
                data = _b.sent();
                clientAccounts = data === null || data === void 0 ? void 0 : data.clients.map(function (c) { return new ClientAccount_1.default(c); });
                if (!(version === 'v1')) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsSuccess(clientAccounts, clientId, customerAccountId, sectionSubscriptionId))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4:
                if (!(version === 'v2')) return [3 /*break*/, 6];
                clientFamilies = data.families.map(function (clientFamily) {
                    return new ClientFamily_1.default(clientFamily);
                });
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsSuccess(clientAccounts, clientId, customerAccountId, sectionSubscriptionId, clientFamilies, data.isClientEligible, familyId))];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 14];
            case 7:
                e_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 8:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_1)) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsFailure(errorMsg))];
            case 11:
                _b.sent();
                _b.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getClientAccountsEffect.name))];
            case 13:
                _b.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function addContractEffect(action) {
    var token, e_2, language, errorMsg;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _f.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _f.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.addContract, action.payload.clientReference, action.payload.clientName, action.payload.contractName, token)];
            case 2:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.addContractSuccess())];
            case 3:
                _f.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsData({
                        clientId: action.payload.clientId,
                        version: 'v1'
                    }))];
            case 4:
                _f.sent();
                return [3 /*break*/, 12];
            case 5:
                e_2 = _f.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_f.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (((_a = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    errorMsg = (0, effectsHelper_1.returnErrorMessage)((_b = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _b === void 0 ? void 0 : _b.data, (0, i18n_1.default)(language).common.wrongStatusAtAddition, (0, i18n_1.default)(language).forms.addContract.referenceNameMatchingError, 'Found with unexpected status');
                }
                if (((_c = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _c === void 0 ? void 0 : _c.status) === 409)
                    errorMsg =
                        (0, i18n_1.default)(language).forms.addContract
                            .referenceUsedByAnotherAccountError;
                if (((_d = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _d === void 0 ? void 0 : _d.status) === 409 &&
                    ((_e = e_2 === null || e_2 === void 0 ? void 0 : e_2.response) === null || _e === void 0 ? void 0 : _e.data) === 'UserAlreadyLinkedToWebsiteArea')
                    errorMsg =
                        (0, i18n_1.default)(language).forms.addContract.alreadyIncludedReferenceError;
                if (!(0, utils_1.unauthorizedError)(e_2)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _f.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.addContractFailure(errorMsg))];
            case 9:
                _f.sent();
                _f.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, addContractEffect.name))];
            case 11:
                _f.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function addContractV2Effect(action) {
    var token, e_3, language, errorMsg, responseStatus, responseBody;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _c.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.addContract, action.payload.clientReference, action.payload.clientName, action.payload.contractName, token, 'v2')];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.addContractV2Success())];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsData({
                        clientId: action.payload.clientId,
                        version: 'v1'
                    }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 12];
            case 5:
                e_3 = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_c.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                responseStatus = (_a = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _a === void 0 ? void 0 : _a.status;
                responseBody = (_b = e_3 === null || e_3 === void 0 ? void 0 : e_3.response) === null || _b === void 0 ? void 0 : _b.data;
                switch (responseStatus) {
                    case 403:
                        // Code d'erreur pour un blocage WAF
                        errorMsg = (0, i18n_1.default)(language).common.wafBlockingError;
                        break;
                    case 404:
                        // Code d'erreur pour utilisateur non retrouvé (scénario improbable lors d'un appel fait par le widgets ou le mobile)
                        if (responseBody === 'UserNotFound')
                            errorMsg = (0, i18n_1.default)(language).forms.addContract.userNotFound;
                        // Code d'erreur pour client non retrouvé
                        else if (responseBody === 'ClientNotFound')
                            errorMsg = (0, i18n_1.default)(language).forms.addContract.referenceNameMatchingError;
                        break;
                    case 409:
                        // Code d'erreur pour client déjà associé à un espace client
                        errorMsg = (0, i18n_1.default)(language).forms.addContract.referenceUsedByAnotherAccountError;
                        break;
                    case 422:
                        // Code d'erreur pour client retrouvé mais pas avec le statut actif
                        if (responseBody === 'ClientFoundWithUnexpectedStatus')
                            errorMsg = (0, i18n_1.default)(language).common.wrongStatusAtAddition;
                        // Code d'erreur pour client n'ayant pas de contrats actifs ou est en relève seule
                        else if (responseBody === 'ClientHasNoActiveOrRecentlyTerminatedContracts')
                            errorMsg = (0, i18n_1.default)(language).forms.addContract.clientHasNoActiveOrRecentlyTerminatedContracts;
                        // Code d'erreur pour client en relève seule
                        else if (responseBody === 'ClientHasNoBillingAgreements')
                            errorMsg = (0, i18n_1.default)(language).forms.addContract.clientHasNoBillingAgreements;
                        break;
                    case 502:
                        // Code d'erreur lié aux problèmes réseau (502)
                        errorMsg = (0, i18n_1.default)(language).common.network502Error;
                        break;
                    case 503:
                        // Code d'erreur lié aux problèmes réseau (503)
                        errorMsg = (0, i18n_1.default)(language).common.network503Error;
                        break;
                    case 504:
                        // Code d'erreur lié aux problèmes réseau (504)
                        errorMsg = (0, i18n_1.default)(language).common.network504Error;
                        break;
                    default:
                        break;
                }
                if (!(0, utils_1.unauthorizedError)(e_3)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _c.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.addContractV2Failure(errorMsg))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_3, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, addContractV2Effect.name))];
            case 11:
                _c.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function updateSelectedContract() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.updateSelectedContract())];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateContractNameEffect(action) {
    var token, error_1, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 12]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.updateContractNameService, action.payload.contractName, action.payload.clientid, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.updateContractNameSuccess())];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getClientAccountsData({
                        clientId: action.payload.clientid,
                        version: 'v1'
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 12];
            case 5:
                error_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(error_1)) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.updateContractNameFailure(errorMsg))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_1, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateContractNameEffect.name))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function removeContractEffect(action) {
    var token, e_4, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.removeContractService, token, action.payload.clientId)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.removeContractSuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_4)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.removeContractFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_4, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, removeContractEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function deleteFamilyEffect(action) {
    var token, e_5, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 11]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.deleteFamilyService, token, action.payload)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.deleteFamilySuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 11];
            case 4:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                if (!(0, utils_1.unauthorizedError)(e_5)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)(authState_1.authActions.logout())];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.deleteFamilyFailure(errorMsg))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_5, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, deleteFamilyEffect.name))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function createFamilyEffect(action) {
    var token, data, createdFamily, e_6, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.createFamilyService, action.payload, token)];
            case 2:
                data = _a.sent();
                createdFamily = new ClientFamily_1.default({
                    familyId: data.familyId,
                    familyName: data.familyName,
                    familyPairingTechnologyCode: data.familyPairingTechnologyCode,
                    sectionSubscriptions: action.payload.sectionsSubscriptions
                });
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.createFamilySuccess(createdFamily))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_6 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.createFamilyFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_6, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, createFamilyEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateFamilyEffect(action) {
    var token, e_7, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.updateFamilyService, action.payload, token)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.updateFamilySuccess(action.payload))];
            case 3:
                _a.sent();
                return [3 /*break*/, 8];
            case 4:
                e_7 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.updateFamilyFailure(errorMsg))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_7, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, updateFamilyEffect.name))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function renameSectionSubscriptionEffect(action) {
    var token, response, e_8, language, errorMsg;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _a.sent();
                if (!token)
                    throw Error('Missing Access Token');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.renameSectionSubscriptionService, action.payload, token)];
            case 2:
                response = _a.sent();
                if (!(response.status === 204)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.renameSectionSubscriptionSuccess(action.payload))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 9];
            case 5:
                e_8 = _a.sent();
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 6:
                language = (_a.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.renameSectionSubscriptionFailure(errorMsg))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, e_8, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, renameSectionSubscriptionEffect.name))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getEligibilityCoachConsoEffect(action) {
    var token, payload, args, customerAccountId, locale, response, error_2, data, language, errorMsg;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 8]);
                return [4 /*yield*/, (0, effects_1.select)(authSelectors_1.getAccessToken)];
            case 1:
                token = _b.sent();
                if (!token)
                    throw Error('Missing Access Token');
                payload = action.payload, args = action.args;
                customerAccountId = (args ? payload[0] : payload);
                locale = (args ? payload[1] : 'en');
                return [4 /*yield*/, (0, effects_1.call)(clientAccountsService_1.getEligibilityCoachConsoService, token, customerAccountId, locale)];
            case 2:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getEligibilityCoachConsoSuccess(response.data))];
            case 3:
                _b.sent();
                return [3 /*break*/, 8];
            case 4:
                error_2 = _b.sent();
                data = null;
                // Here we need to use the reponse body when we got 404
                if (axios_1.default.isAxiosError(error_2) && ((_a = error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 404) {
                    data = error_2.response.data;
                }
                return [4 /*yield*/, (0, effects_1.select)(settingsSelectors_1.getSettingsState)];
            case 5:
                language = (_b.sent()).language;
                errorMsg = (0, i18n_1.default)(language).api.auth.errors.unknownError;
                return [4 /*yield*/, (0, effects_1.put)(ClientAccountsState_1.clientAccountsActions.getEligibilityCoachConsoFailure(errorMsg, data))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.call)(reportErrorsToInstrumentation_1.default, error_2, reportErrorsToInstrumentation_1.ErrorSourceType.DATA_INTEGRITY_ERROR, (0, reportErrorsToInstrumentation_1.getCorrelationId)(0, getEligibilityCoachConsoEffect.name))];
            case 7:
                _b.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function consumerEffects() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.getClientAccountsData.type, getClientAccountsEffect)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.addContract.type, addContractEffect)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.addContractV2.type, addContractV2Effect)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.removeContract.type, removeContractEffect)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.updateContractName.type, updateContractNameEffect)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.getClientAccountsSuccess.type, updateSelectedContract)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.deleteFamily.type, deleteFamilyEffect)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.createFamily.type, createFamilyEffect)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.updateFamily.type, updateFamilyEffect)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.renameSectionSubscription.type, renameSectionSubscriptionEffect)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(ClientAccountsState_1.clientAccountsActions.getEligibilityCoachConso.type, getEligibilityCoachConsoEffect)];
            case 11:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.default = consumerEffects;
